import { API_ROUTE_ADMIN_TELE_POLICY } from '@/resources/api-routes'
import { update } from '@/util/auth'

import type { SalaryDeductionProfileOriginal } from './type'

const IS_NEW_BACKEND_API = true

export const updateTelePolicy = async ({
  id,
  payload,
}: {
  id: number
  payload: Pick<
    SalaryDeductionProfileOriginal,
    'name' | 'telePolicyTemplateId' | 'freeAllowanceAmount' | 'comment'
  > & { global: boolean }
}) => {
  const { salaryDeductionProfile } = await update<{
    salaryDeductionProfile: SalaryDeductionProfileOriginal
  }>(API_ROUTE_ADMIN_TELE_POLICY.replace(':id', String(id)), payload, IS_NEW_BACKEND_API)
  return salaryDeductionProfile
}
